import { ComponentProps } from 'react'
import { LuMapPin } from 'react-icons/lu'

import { MapMarker } from '@/feature/map'
import { ACTIVE_SEARCH_MARKER, SEARCH_MARKER_COLOR } from '@/feature/observatory'

export type MapSearchMarkerProps = {
  position: ComponentProps<typeof MapMarker>['position']
}

export const MapSearchMarker = ({ position }: MapSearchMarkerProps) => (
  <MapMarker position={position} zIndex={ACTIVE_SEARCH_MARKER} clusterer={false}>
    <LuMapPin size={33} color={SEARCH_MARKER_COLOR} />
  </MapMarker>
)
